/**
 * This file is auto-generated by build-enums. Do not edit directly.
 * Instead run `pnpm --filter @prophecy/graphql-types run build-enums`
 *
 * This file contains all the enums defined in the GraphQL schema.
 * It also contains a type for each enum that is a string literal of the enum name.
 * This is useful for type safety when using the enum in the frontend.
 */
export var ExternalGitProvider;
(function (ExternalGitProvider) {
    ExternalGitProvider["Github"] = "Github";
    ExternalGitProvider["GithubEnterprise"] = "GithubEnterprise";
    ExternalGitProvider["AzureDevOps"] = "AzureDevOps";
    ExternalGitProvider["BitBucket"] = "BitBucket";
    ExternalGitProvider["GitLab"] = "GitLab";
    ExternalGitProvider["GitLabEnterprise"] = "GitLabEnterprise";
    ExternalGitProvider["Other"] = "Other";
    ExternalGitProvider["ProphecyManaged"] = "ProphecyManaged";
    ExternalGitProvider["Unknown"] = "Unknown";
})(ExternalGitProvider || (ExternalGitProvider = {}));
export var InvitationStatus;
(function (InvitationStatus) {
    InvitationStatus["accepted"] = "accepted";
    InvitationStatus["rejected"] = "rejected";
    InvitationStatus["requested"] = "requested";
    InvitationStatus["requestedWithSeat"] = "requestedWithSeat";
    InvitationStatus["suspended"] = "suspended";
    InvitationStatus["received"] = "received";
})(InvitationStatus || (InvitationStatus = {}));
export var VersionControlMode;
(function (VersionControlMode) {
    VersionControlMode["Simple"] = "Simple";
    VersionControlMode["Advanced"] = "Advanced";
})(VersionControlMode || (VersionControlMode = {}));
export var Version;
(function (Version) {
    Version["Draft"] = "Draft";
    Version["Published"] = "Published";
})(Version || (Version = {}));
export var BackEndCodeLanguage;
(function (BackEndCodeLanguage) {
    BackEndCodeLanguage["scala"] = "scala";
    BackEndCodeLanguage["python"] = "python";
    BackEndCodeLanguage["sql"] = "sql";
})(BackEndCodeLanguage || (BackEndCodeLanguage = {}));
export var GitProvider;
(function (GitProvider) {
    GitProvider["ProphecyManaged"] = "ProphecyManaged";
    GitProvider["External"] = "External";
})(GitProvider || (GitProvider = {}));
export var ProfessionalEditionPlan;
(function (ProfessionalEditionPlan) {
    ProfessionalEditionPlan["Starter"] = "Starter";
    ProfessionalEditionPlan["Pro"] = "Pro";
    ProfessionalEditionPlan["Enterprise"] = "Enterprise";
})(ProfessionalEditionPlan || (ProfessionalEditionPlan = {}));
export var TeamState;
(function (TeamState) {
    TeamState["enabled"] = "enabled";
    TeamState["disabled"] = "disabled";
})(TeamState || (TeamState = {}));
export var GitCombinedStorageModel;
(function (GitCombinedStorageModel) {
    GitCombinedStorageModel["Simple"] = "Simple";
    GitCombinedStorageModel["Normal"] = "Normal";
    GitCombinedStorageModel["NormalWithForks"] = "NormalWithForks";
})(GitCombinedStorageModel || (GitCombinedStorageModel = {}));
export var WorkflowMode;
(function (WorkflowMode) {
    WorkflowMode["batch"] = "batch";
    WorkflowMode["stream"] = "stream";
})(WorkflowMode || (WorkflowMode = {}));
export var BuildSystem;
(function (BuildSystem) {
    BuildSystem["maven"] = "maven";
    BuildSystem["wheel"] = "wheel";
    BuildSystem["sql"] = "sql";
})(BuildSystem || (BuildSystem = {}));
export var DefaultTransformationEntity;
(function (DefaultTransformationEntity) {
    DefaultTransformationEntity["Model"] = "Model";
    DefaultTransformationEntity["Pipeline"] = "Pipeline";
})(DefaultTransformationEntity || (DefaultTransformationEntity = {}));
export var MergeStatus;
(function (MergeStatus) {
    MergeStatus["Success"] = "Success";
    MergeStatus["Conflicted"] = "Conflicted";
})(MergeStatus || (MergeStatus = {}));
/** Supported aspect types */
export var AspectKind;
(function (AspectKind) {
    /** List of Pipeline in job */
    AspectKind["PipelinesInJob"] = "PipelinesInJob";
    /** Data quality expectations */
    AspectKind["DataQualityExpectation"] = "DataQualityExpectation";
    /** Dependency information */
    AspectKind["Dependency"] = "Dependency";
    /** Version information */
    AspectKind["Version"] = "Version";
    /** Configuration content. Versioned. */
    AspectKind["Configuration"] = "Configuration";
    /** Hive metastore related information. */
    AspectKind["Storage"] = "Storage";
    /** Airflow connections info */
    AspectKind["AirflowConnectionInfo"] = "AirflowConnectionInfo";
    /** Unit test execution result information */
    AspectKind["TestResult"] = "TestResult";
    /** Dag Information  */
    AspectKind["DagInformation"] = "DagInformation";
    /** Job size information like resources etc. */
    AspectKind["JobSize"] = "JobSize";
    /** Spark Provider Information for a fabric */
    AspectKind["SparkProviderInfo"] = "SparkProviderInfo";
    /** Airflow Provider Information for a fabric */
    AspectKind["AirflowProviderInfo"] = "AirflowProviderInfo";
    /** Sql Provider Information for a fabric */
    AspectKind["SqlProviderInfo"] = "SqlProviderInfo";
    /** Orchestration Provider Information for a fabric */
    AspectKind["OrchestrationProviderInfo"] = "OrchestrationProviderInfo";
    /** DQ Provider Information for a fabric */
    AspectKind["DQProviderInfo"] = "DQProviderInfo";
    /** SQL fabric creds info */
    AspectKind["SqlFabricCredsInfo"] = "SqlFabricCredsInfo";
    /** Code content. Versioned. */
    AspectKind["Code"] = "Code";
    /** Unit Tests. Versioned. */
    AspectKind["TestVisual"] = "TestVisual";
    /** Dataset schema information */
    AspectKind["Schema"] = "Schema";
    /** Version information of Entity */
    AspectKind["MigrationInfo"] = "MigrationInfo";
    /** Commit ids sorted by date for deploy option in scheduler */
    AspectKind["ListCommits"] = "ListCommits";
    /** Git storage information like repo url etc. */
    AspectKind["GitStorage"] = "GitStorage";
    /** Git storage information like repo url etc. for Projects */
    AspectKind["GitConfig"] = "GitConfig";
    /** General information like description */
    AspectKind["Info"] = "Info";
    /** Code dependency information */
    AspectKind["CodeDeps"] = "CodeDeps";
    /** Lineage Branch information */
    AspectKind["LineageBranch"] = "LineageBranch";
    /** Lineage */
    AspectKind["Lineage"] = "Lineage";
    /** Project's initial config include description and dependency details */
    AspectKind["ProjectInitialConfig"] = "ProjectInitialConfig";
    /** Lineage Release information */
    AspectKind["LineageRelease"] = "LineageRelease";
    /** Lineage Commit information */
    AspectKind["LineageCommit"] = "LineageCommit";
    /** Cluster information */
    AspectKind["ClusterInfo"] = "ClusterInfo";
    /** User fabric info for all fabrics */
    AspectKind["UserAllFabricInfo"] = "UserAllFabricInfo";
    /** Onboarding info */
    AspectKind["OnboardingInfo"] = "OnboardingInfo";
    /** Livy proxy user */
    AspectKind["LivyProxyUser"] = "LivyProxyUser";
    /** Job Deployment Airflow Info */
    AspectKind["JobDeploymentAirflowInfo"] = "JobDeploymentAirflowInfo";
    /** ExpressionInfo */
    AspectKind["ExpressionsInfo"] = "ExpressionsInfo";
    /** Databricks Deployment */
    AspectKind["DatabricksDeployment"] = "DatabricksDeployment";
    /** Run Info */
    AspectKind["RunInfo"] = "RunInfo";
    /** Transpiler Import Input Info */
    AspectKind["InputInfo"] = "InputInfo";
    /** Transpiler Import Output Pipeline Info */
    AspectKind["OutputInfo"] = "OutputInfo";
    /** Detailed information for datasets in Pipeline Runs */
    AspectKind["DatasetDetails"] = "DatasetDetails";
    /** Interim content for a dataset */
    AspectKind["Interim"] = "Interim";
    /** Partner Info aspect */
    AspectKind["PartnerInfo"] = "PartnerInfo";
    /** Resolution Mode for library */
    AspectKind["ResolutionModeInfo"] = "ResolutionModeInfo";
    /** SQL Info */
    AspectKind["SQLInfo"] = "SQLInfo";
    /** Admin level information for an entity */
    AspectKind["AdminInfo"] = "AdminInfo";
    /** NonVersioned Code (branch) */
    AspectKind["NonVersionedCodeBranch"] = "NonVersionedCodeBranch";
    /** NonVersioned Code (commit) */
    AspectKind["NonVersionedCodeCommit"] = "NonVersionedCodeCommit";
    /** ProphecyManaged Fabric Service Principal Info */
    AspectKind["FabricServicePrincipalInfo"] = "FabricServicePrincipalInfo";
    /** OIDC Info */
    AspectKind["OIDCInfo"] = "OIDCInfo";
    /** Job files SHA aspect */
    AspectKind["JobFilesSHA"] = "JobFilesSHA";
    /** Airflow Connections Info */
    AspectKind["AirflowConnections"] = "AirflowConnections";
    /** Deployment State */
    AspectKind["DeploymentState"] = "DeploymentState";
    /** Project Deployment Settings */
    AspectKind["DeploymentSettings"] = "DeploymentSettings";
    /** Fabric Service principal state */
    AspectKind["FabricServicePrincipalState"] = "FabricServicePrincipalState";
    /** Build cache */
    AspectKind["BuildCache"] = "BuildCache";
    /** Enabled transpilers for that team */
    AspectKind["EnabledTranspilers"] = "EnabledTranspilers";
    /** OAuth information for a user-host combination */
    AspectKind["UserOAuth"] = "UserOAuth";
    /** Project Creation Default settings */
    AspectKind["ProjectCreationDefaults"] = "ProjectCreationDefaults";
})(AspectKind || (AspectKind = {}));
/** SelectionType */
export var Section;
(function (Section) {
    /** EntityAndAspects */
    Section["EntityAndAspects"] = "EntityAndAspects";
    /** Author */
    Section["Author"] = "Author";
    /** Team */
    Section["Team"] = "Team";
    /** Project */
    Section["Project"] = "Project";
    /** Recency */
    Section["Recency"] = "Recency";
})(Section || (Section = {}));
/** ItemSelectionType */
export var ItemSelection;
(function (ItemSelection) {
    ItemSelection["AtMostOne"] = "AtMostOne";
    ItemSelection["ExactlyOne"] = "ExactlyOne";
    ItemSelection["Many"] = "Many";
})(ItemSelection || (ItemSelection = {}));
/** Type of search term for in-memory search */
export var Search;
(function (Search) {
    /** Match by entity name */
    Search["Name"] = "Name";
    /** Match by column name */
    Search["Column"] = "Column";
})(Search || (Search = {}));
/** Supported entity types */
export var EntityKind;
(function (EntityKind) {
    /** Deployment Entity */
    EntityKind["Deployment"] = "Deployment";
    /** Entity Deployment */
    EntityKind["EntityDeployment"] = "EntityDeployment";
    /** Repository Entity */
    EntityKind["Repository"] = "Repository";
    /** Team Entity */
    EntityKind["Team"] = "Team";
    /** Dataset Entity */
    EntityKind["Dataset"] = "Dataset";
    /** Stored Procedure */
    EntityKind["StoredProcedure"] = "StoredProcedure";
    /** Schedule Entity - renamed to Job */
    EntityKind["Schedule"] = "Schedule";
    /** Job Entity */
    EntityKind["Job"] = "Job";
    /** PhysicalDataset Entity */
    EntityKind["PhysicalDataset"] = "PhysicalDataset";
    /** Workflow Entity - renamed to Pipeline */
    EntityKind["Workflow"] = "Workflow";
    /** Pipeline Entity */
    EntityKind["Pipeline"] = "Pipeline";
    /** Project Entity */
    EntityKind["Project"] = "Project";
    /** Subgraph Entity */
    EntityKind["Subgraph"] = "Subgraph";
    /** SQLModel Entity */
    EntityKind["SQLModel"] = "SQLModel";
    /** SQLMacro Entity */
    EntityKind["SQLMacro"] = "SQLMacro";
    /** SQLSeed Entity */
    EntityKind["SQLSeed"] = "SQLSeed";
    /** SQLSource Entity */
    EntityKind["SQLSource"] = "SQLSource";
    /** SQLTable Entity */
    EntityKind["SQLTable"] = "SQLTable";
    /** SQLUnreferencedSource Entity */
    EntityKind["SQLUnreferencedSource"] = "SQLUnreferencedSource";
    /** SQLPipeline Entity */
    EntityKind["SQLPipeline"] = "SQLPipeline";
    /** SQLSnapshot Entity */
    EntityKind["SQLSnapshot"] = "SQLSnapshot";
    /** SQLTest Entity */
    EntityKind["SQLTest"] = "SQLTest";
    /** SQL Orchestrator Pipeline */
    EntityKind["SQLOrchestratorPipeline"] = "SQLOrchestratorPipeline";
    /** SQL BusinessApp */
    EntityKind["SQLBusinessApp"] = "SQLBusinessApp";
    /** SQL Stored Procedure */
    EntityKind["SQLStoredProcedure"] = "SQLStoredProcedure";
    /** Configuration Entity */
    EntityKind["Configuration"] = "Configuration";
    /** PipelineConfigurations Entity */
    EntityKind["PipelineConfigurations"] = "PipelineConfigurations";
    /** User Entity */
    EntityKind["User"] = "User";
    /** Fabric Entity */
    EntityKind["Fabric"] = "Fabric";
    /** Functions Entity */
    EntityKind["Functions"] = "Functions";
    /** Gem Entity */
    EntityKind["Gem"] = "Gem";
    /** Udf Entity */
    EntityKind["UDF"] = "UDF";
    /** Udaf Entity */
    EntityKind["UDAF"] = "UDAF";
    /** BusinessRule Entity */
    EntityKind["BusinessRule"] = "BusinessRule";
    /** Expression Entity */
    EntityKind["Expression"] = "Expression";
    /** Airflow Function Entity */
    EntityKind["AirflowFunction"] = "AirflowFunction";
    /** Dependency Entity */
    EntityKind["Dependency"] = "Dependency";
    /** ProjectRelease Entity */
    EntityKind["ProjectRelease"] = "ProjectRelease";
    /** JobRelease Entity */
    EntityKind["JobRelease"] = "JobRelease";
    /** TranspilerImport Entity */
    EntityKind["TranspilerImport"] = "TranspilerImport";
    /** Template Entity */
    EntityKind["Template"] = "Template";
    /** BulkTranspilerImport Entity */
    EntityKind["BulkTranspilerImport"] = "BulkTranspilerImport";
    /** Fabric Connector */
    EntityKind["Connector"] = "Connector";
    /** Connector Run History */
    EntityKind["ConnectorRunHistory"] = "ConnectorRunHistory";
    /** Interactive Spark Session */
    EntityKind["InteractiveSparkSession"] = "InteractiveSparkSession";
    /** Secrets */
    EntityKind["Secrets"] = "Secrets";
    /** Orchestration Connection Entity */
    EntityKind["OrchestrationConnection"] = "OrchestrationConnection";
    /** Orchestration Secret Entity */
    EntityKind["OrchestrationSecret"] = "OrchestrationSecret";
    /** Orchestrator Deployment */
    EntityKind["OrchestratorDeployment"] = "OrchestratorDeployment";
})(EntityKind || (EntityKind = {}));
/** Supported Commit Log Mutation Type */
export var CommitLogEntityMutation;
(function (CommitLogEntityMutation) {
    /** New Mutation */
    CommitLogEntityMutation["New"] = "New";
    /** Modified Mutation */
    CommitLogEntityMutation["Modified"] = "Modified";
    /** Deleted Mutation */
    CommitLogEntityMutation["Deleted"] = "Deleted";
    /** Unmodified Mutation */
    CommitLogEntityMutation["Unmodified"] = "Unmodified";
})(CommitLogEntityMutation || (CommitLogEntityMutation = {}));
/** Forking Modes for Git Repo */
export var ForkMode;
(function (ForkMode) {
    ForkMode["Multi"] = "Multi";
    ForkMode["Single"] = "Single";
})(ForkMode || (ForkMode = {}));
/** Type of fork of the repository [Master / User] */
export var Fork;
(function (Fork) {
    Fork["Master"] = "Master";
    Fork["User"] = "User";
})(Fork || (Fork = {}));
/** User role in team */
export var Role;
(function (Role) {
    Role["owner"] = "owner";
    Role["admin"] = "admin";
    Role["member"] = "member";
})(Role || (Role = {}));
/** Status for a entity in Deployment */
export var DeploymentEntityStatus;
(function (DeploymentEntityStatus) {
    DeploymentEntityStatus["Added"] = "Added";
    DeploymentEntityStatus["Refreshed"] = "Refreshed";
    DeploymentEntityStatus["Deleted"] = "Deleted";
})(DeploymentEntityStatus || (DeploymentEntityStatus = {}));
/** Deployment Status for a deployment */
export var DeploymentStatus;
(function (DeploymentStatus) {
    DeploymentStatus["NotStated"] = "NotStated";
    DeploymentStatus["Running"] = "Running";
    DeploymentStatus["Succeeded"] = "Succeeded";
    DeploymentStatus["Failed"] = "Failed";
})(DeploymentStatus || (DeploymentStatus = {}));
/** secrets provider types */
export var SecretsProvider;
(function (SecretsProvider) {
    SecretsProvider["Databricks"] = "Databricks";
    SecretsProvider["HashiCorp"] = "HashiCorp";
    SecretsProvider["Environment"] = "Environment";
})(SecretsProvider || (SecretsProvider = {}));
/** Supported resolution types */
export var ResolutionStrategy;
(function (ResolutionStrategy) {
    ResolutionStrategy["LeftBranch"] = "LeftBranch";
    ResolutionStrategy["RightBranch"] = "RightBranch";
})(ResolutionStrategy || (ResolutionStrategy = {}));
export var Industry;
(function (Industry) {
    Industry["Finance"] = "Finance";
    Industry["Healthcare"] = "Healthcare";
    Industry["Manufacturing"] = "Manufacturing";
    Industry["Energy"] = "Energy";
    Industry["Transportation"] = "Transportation";
    Industry["Retail"] = "Retail";
    Industry["Hospitality"] = "Hospitality";
    Industry["Other"] = "Other";
})(Industry || (Industry = {}));
export var Project;
(function (Project) {
    Project["PublicAccess"] = "PublicAccess";
    Project["UserManaged"] = "UserManaged";
})(Project || (Project = {}));
export var Remote;
(function (Remote) {
    Remote["Local"] = "Local";
    Remote["Upstream"] = "Upstream";
    Remote["Origin"] = "Origin";
})(Remote || (Remote = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["Ascending"] = "Ascending";
    SortOrder["Descending"] = "Descending";
})(SortOrder || (SortOrder = {}));
export var SortColumn;
(function (SortColumn) {
    SortColumn["Created"] = "Created";
    SortColumn["Modified"] = "Modified";
})(SortColumn || (SortColumn = {}));
export var GitTagState;
(function (GitTagState) {
    GitTagState["ExternalAndInternallyReleased"] = "ExternalAndInternallyReleased";
    GitTagState["InternalReleased"] = "InternalReleased";
    GitTagState["ExternalUnReleased"] = "ExternalUnReleased";
})(GitTagState || (GitTagState = {}));
/** Project's Git Repos Syncing Modes */
export var SyncMode;
(function (SyncMode) {
    SyncMode["External"] = "External";
    SyncMode["Internal"] = "Internal";
})(SyncMode || (SyncMode = {}));
/** Type of User's Account */
export var UserAccount;
(function (UserAccount) {
    /** Licensed Account for SaSS User */
    UserAccount["CeLicenseAcquired"] = "CeLicenseAcquired";
    /** The Default Account for User */
    UserAccount["Enterprise"] = "Enterprise";
    /** A user coming from AWS */
    UserAccount["AwsMarketplace"] = "AwsMarketplace";
    /** A user coming from Azure */
    UserAccount["AzureMarketplace"] = "AzureMarketplace";
    /** Free Account for SaSS User */
    UserAccount["CeFree"] = "CeFree";
    /** A user coming from Databricks Partner Hub */
    UserAccount["DatabricksPartner"] = "DatabricksPartner";
    /** A user which is on Enterprise Trial */
    UserAccount["EnterpriseTrial"] = "EnterpriseTrial";
    /** A user to manage Prophecy cluster */
    UserAccount["ClusterAdmin"] = "ClusterAdmin";
    /** A support user to manage Prophecy IDE */
    UserAccount["Support"] = "Support";
})(UserAccount || (UserAccount = {}));
/** The user managed type */
export var UserManaged;
(function (UserManaged) {
    /** The prophecy managed user type */
    UserManaged["ProphecyManaged"] = "ProphecyManaged";
    /** The LDAP managed user type */
    UserManaged["Ldap"] = "Ldap";
    /** The SAML managed user type */
    UserManaged["Saml"] = "Saml";
    /** The AzureAD managed user type */
    UserManaged["AzureAd"] = "AzureAd";
    /** The Google managed user type */
    UserManaged["Google"] = "Google";
})(UserManaged || (UserManaged = {}));
/** The user managed type */
export var UserAttribute;
(function (UserAttribute) {
    /** default attribute */
    UserAttribute["DefaultAttr"] = "DefaultAttr";
    /** attribute through which user can deploy */
    UserAttribute["DeploymentAttr"] = "DeploymentAttr";
})(UserAttribute || (UserAttribute = {}));
/** Scheduler Enum */
export var Scheduler;
(function (Scheduler) {
    /** Amazon Managed Workflows for Apache Airflow */
    Scheduler["MWAA"] = "MWAA";
    /** Astronomer - Airflow */
    Scheduler["Astronomer"] = "Astronomer";
    /** Databricks Jobs */
    Scheduler["Databricks"] = "Databricks";
    /** Composer */
    Scheduler["Composer"] = "Composer";
    /** Open source */
    Scheduler["Prophecy"] = "Prophecy";
    /** Open source */
    Scheduler["OpenSource"] = "OpenSource";
})(Scheduler || (Scheduler = {}));
/** Cloud Provider Enum */
export var CloudProvider;
(function (CloudProvider) {
    /** Amazon Web Services */
    CloudProvider["AWS"] = "AWS";
    /** Microsoft Azure */
    CloudProvider["Azure"] = "Azure";
    /** Google Cloud Provider */
    CloudProvider["GCP"] = "GCP";
})(CloudProvider || (CloudProvider = {}));
/** Release Status enum */
export var Status;
(function (Status) {
    /** Pending, Not Started */
    Status["Pending"] = "Pending";
    /** RUNNING */
    Status["Running"] = "Running";
    /** Succeeded */
    Status["Succeeded"] = "Succeeded";
    /** Retrying */
    Status["Retrying"] = "Retrying";
    /** Failed */
    Status["Failed"] = "Failed";
})(Status || (Status = {}));
export var TeamKind;
(function (TeamKind) {
    TeamKind["ProphecyManaged"] = "ProphecyManaged";
    TeamKind["ProphecyManagedPersonal"] = "ProphecyManagedPersonal";
    TeamKind["IdpOrganizationWide"] = "IdpOrganizationWide";
    TeamKind["IdpGroup"] = "IdpGroup";
})(TeamKind || (TeamKind = {}));
export var ConnectionRunStatus;
(function (ConnectionRunStatus) {
    ConnectionRunStatus["Running"] = "Running";
    ConnectionRunStatus["CompletedSuccessfully"] = "CompletedSuccessfully";
})(ConnectionRunStatus || (ConnectionRunStatus = {}));
export var AWSAccessProvider;
(function (AWSAccessProvider) {
    AWSAccessProvider["USER_PROVIDED_CREDENTIALS"] = "USER_PROVIDED_CREDENTIALS";
    AWSAccessProvider["FABRIC_PROVIDED_CREDENTIALS"] = "FABRIC_PROVIDED_CREDENTIALS";
    AWSAccessProvider["ENVIRONMENT_PROVIDED_CREDENTIALS"] = "ENVIRONMENT_PROVIDED_CREDENTIALS";
    AWSAccessProvider["ARN_PROVIDED_CREDENTIALS"] = "ARN_PROVIDED_CREDENTIALS";
})(AWSAccessProvider || (AWSAccessProvider = {}));
export var Connector;
(function (Connector) {
    Connector["DatabricksConnectorType"] = "DatabricksConnectorType";
    Connector["GlueConnectorType"] = "GlueConnectorType";
})(Connector || (Connector = {}));
export var ShareScope;
(function (ShareScope) {
    ShareScope["Public"] = "Public";
    ShareScope["Private"] = "Private";
    ShareScope["NoAccess"] = "NoAccess";
})(ShareScope || (ShareScope = {}));
export var Link;
(function (Link) {
    Link["Snapshot"] = "Snapshot";
    Link["Live"] = "Live";
})(Link || (Link = {}));
/** Type of file system entry */
export var FileEntry;
(function (FileEntry) {
    FileEntry["File"] = "File";
    FileEntry["Directory"] = "Directory";
})(FileEntry || (FileEntry = {}));
